<template>
  <button @click="onClickPrint">
    <span class="icon icon-print"></span>
  </button>
</template>

<script>
export default {
  methods: {
    onClickPrint () {
      window.print()
    }
  }
}
</script>
